export interface MerchantLoanActivityMetric {
  merchantId: string
  totalApplications: number
  totalApplicationsAmount: number
  totalCreatedLoans: number
  totalGrantedAmount: number
  totalApprovedApplications: number
  totalMaxApprovalAmount: number
  totalPromoApplicationsWorksheet: number
  totalPromoApprovedWorksheetsAmountAfterMdr: number
  date: string
}

export interface MerchantLoanActivityMetricsDto {
  merchantId: string
  fromDate: string
  toDate: string
}

export enum AggregationPeriod {
  Daily = 'daily',
  Weekly = 'weekly',
  Monthly = 'monthly',
}

export const COUNT_METRIC_KEYS = [
  'totalApplications',
  'totalCreatedLoans',
  'totalApprovedApplications',
  'totalPromoApplicationsWorksheet',
] as const

export const AMOUNT_METRIC_KEYS = [
  'totalApplicationsAmount',
  'totalGrantedAmount',
  'totalMaxApprovalAmount',
  'totalPromoApprovedWorksheetsAmountAfterMdr',
] as const

export const METRIC_KEYS = [...COUNT_METRIC_KEYS, ...AMOUNT_METRIC_KEYS] as const

export type CountMetricKey = (typeof COUNT_METRIC_KEYS)[number]
export type AmountMetricKey = (typeof AMOUNT_METRIC_KEYS)[number]
export type MetricKey = (typeof METRIC_KEYS)[number]

export enum MetricDisplayMode {
  Count = 'count',
  Amount = 'amount',
}
